const modeller2d = {
    makeCircle(fn) {
        let points = [];
        for (let i = 0; i < fn; i++) {
            let rad = i / fn * Math.PI * 2;
            points.push(new THREE.Vector2(Math.cos(rad), Math.sin(rad)));
        }
        return points;
    },

    // r1，外侧大圆
    makeRing(r1, r2, fn) {
        let points1 = [];
        let points2 = [];
        for (let i = 0; i < fn; i++) {
            let rad = i / fn * Math.PI * 2;
            let cos = Math.cos(rad),
                sin = Math.sin(rad);
            points1.push(new THREE.Vector2(r1 * cos, r1 * sin));
            points2.push(new THREE.Vector2(r2 * cos, r2 * sin));
        }
        return [points1, points2];
    },

    makeRect(x1, x2, y1, y2) {
        return [
            new THREE.Vector2(x1, y1),
            new THREE.Vector2(x2, y1),
            new THREE.Vector2(x2, y2),
            new THREE.Vector2(x1, y2),
        ];
    },

    makeRoundRect(x1, x2, y1, y2, r, fn) {
        if (r === 0) return this.makeRect(x1, x2, y1, y2);

        fn = fn || 32;
        let points = [new THREE.Vector2(x2, y2 - r)];
        for (let i = 1; i < fn; i++) {
            let rad = i / fn * Math.PI * 0.5;
            points.push(new THREE.Vector2(Math.cos(rad) * r + x2 - r, Math.sin(rad) * r + y2 - r));
        }
        points.push(new THREE.Vector2(x2 - r, y2));

        points.push(new THREE.Vector2(x1 + r, y2));
        for (let i = 1; i < fn; i++) {
            let rad = i / fn * Math.PI * 0.5 + Math.PI * 0.5;
            points.push(new THREE.Vector2(Math.cos(rad) * r + x1 + r, Math.sin(rad) * r + y2 - r));
        }
        points.push(new THREE.Vector2(x1, y2 - r));

        points.push(new THREE.Vector2(x1, y1 + r));
        for (let i = 1; i < fn; i++) {
            let rad = i / fn * Math.PI * 0.5 + Math.PI;
            points.push(new THREE.Vector2(Math.cos(rad) * r + x1 + r, Math.sin(rad) * r + y1 + r));
        }
        points.push(new THREE.Vector2(x1 + r, y1));

        points.push(new THREE.Vector2(x2 - r, y1));
        for (let i = 1; i < fn; i++) {
            let rad = i / fn * Math.PI * 0.5 + Math.PI * 1.5;
            points.push(new THREE.Vector2(Math.cos(rad) * r + x2 - r, Math.sin(rad) * r + y1 + r));
        }
        points.push(new THREE.Vector2(x2, y1 + r));

        return points;
    },

    makeArc(cx, cy, r, startRad, endRad, fn) {
        let points = [];
        let radRange = endRad - startRad;
        // 实际点的数量是fn+1
        for (let i = 0; i <= fn; i++) {
            let rad = i / fn * radRange + startRad;
            points.push(new THREE.Vector2(cx + r * Math.cos(rad), cy + r * Math.sin(rad)));
        }
        return points;
    },

    makeEllipse(cx, cy, r1, r2, startRad, endRad, fn) {
        let points = [];
        let radRange = endRad - startRad;
        // 实际点的数量是fn+1
        for (let i = 0; i <= fn; i++) {
            let rad = i / fn * radRange + startRad;
            points.push(new THREE.Vector2(cx + r1 * Math.cos(rad), cy + r2 * Math.sin(rad)));
        }
        return points;
    },

    getBoundingCircle(points) {
        let cir = new Circle();
        for (let i = 2, n = points.length; i < n; i++) {
            let p = points[i];
            if (cir.outside(p)) { //若第i个点在圆外
                cir.radius = 0;
                cir.center.copy(p); // 由第i个点确定一个圆
                for (let j = i - 1; j >= 0; j--) {
                    let p2 = points[j];
                    if (cir.outside(p2)) { // 若j点不在由i构成的圆内，则由i，j确定一个圆
                        cir.fromTwoPoints(p, p2);
                        for (let k = j + 1; k < i; k++) {
                            let p3 = points[k];
                            if (cir.outside(p3)) { //j到i间的点不再i，j围城的圆内，则有i，j，k确定圆，这里i，j，k三点一定是锐角三角形。
                                cir.fromThreePoints(p, p2, p3);
                            }
                        }

                    }

                }
            }
        }
        return cir;
    },

    mapShapePath(shapePath, func) {
        return {
            shape: shapePath.shape.map(func),
            holes: shapePath.holes.map(hole => hole.map(func))
        };
    },

    rotate90(p) {
        let tmp = p.x;
        p.x = -p.y;
        p.y = tmp;
        return p;
    }
};

export const modeller = {
    addTriangle(vertices, a, b, c) {
        vertices.push(a.x, a.y, a.z, b.x, b.y, b.z, c.x, c.y, c.z);
    },
    addRect(vertices, a, b, c, d) {
        this.addTriangle(vertices, a, b, c);
        this.addTriangle(vertices, a, c, d);
    },

    // 两个条带，连接起来
    addBound(vertices, poly1, poly2) {
        let v2_1 = poly1[poly1.length - 1];
        let v2_2 = poly2[poly2.length - 1];
        for (let i = 0; i < poly1.length; i++) {
            let v1_1 = poly1[i];
            let v1_2 = poly2[i];
            this.addRect(vertices, v2_1, v1_1, v1_2, v2_2);

            v2_1 = v1_1;
            v2_2 = v1_2;
        }
    },

    // 两个条带，连接起来
    addBoundWithKnockout(vertices, poly1, poly2, knockouts) {
        let v2_1 = poly1[poly1.length - 1];
        let v2_2 = poly2[poly2.length - 1];
        for (let i = 0; i < poly1.length; i++) {
            let v1_1 = poly1[i];
            let v1_2 = poly2[i];
            if (!knockouts.has(i)) {
                this.addRect(vertices, v2_1, v1_1, v1_2, v2_2);
            }

            v2_1 = v1_1;
            v2_2 = v1_2;
        }
    },

    // 圆，圆心
    addCircle(vertices, circle, center) {
        for (let i = 0, j = circle.length - 1; i < circle.length; j = i, i++) {
            vertices.push(
                center.x, center.y, center.z,
                circle[i].x, circle[i].y, circle[i].z,
                circle[j].x, circle[j].y, circle[j].z
            );
        }
    },


    addRectZ(vertices, x1, x2, y1, y2, z) {
        vertices.push(x2, y1, z, x1, y1, z, x2, y2, z);
        vertices.push(x2, y2, z, x1, y1, z, x1, y2, z);
    },

    addRectY(vertices, x1, x2, z1, z2, y) {
        vertices.push(x2, y, z2, x1, y, z1, x2, y, z1);
        vertices.push(x1, y, z2, x1, y, z1, x2, y, z2);
    },

    addRectX(vertices, y1, y2, z1, z2, x) {
        vertices.push(x, y2, z1, x, y1, z1, x, y2, z2);
        vertices.push(x, y2, z2, x, y1, z1, x, y1, z2);
    },

    addBox(vertices, x1, x2, y1, y2, z1, z2) {
        this.addRectZ(vertices, x1, x2, y1, y2, z1);
        this.addRectZ(vertices, x2, x1, y1, y2, z2);
        this.addRectY(vertices, x1, x2, z1, z2, y1);
        this.addRectY(vertices, x2, x1, z1, z2, y2);
        this.addRectX(vertices, y1, y2, z1, z2, x1);
        this.addRectX(vertices, y2, y1, z1, z2, x2);
    },

    // 两个条带，连接起来
    addBoundOpen(vertices, poly1, poly2) {
        let v2_1 = poly1[0];
        let v2_2 = poly2[0];
        for (let i = 1; i < poly1.length; i++) {
            let v1_1 = poly1[i];
            let v1_2 = poly2[i];
            this.addRect(vertices, v2_1, v1_1, v1_2, v2_2);

            v2_1 = v1_1;
            v2_2 = v1_2;
        }
    },

    addBoundsZOpen(vertices, ps, z1, z2) {
        // 内壁
        for (let i = 1, last = ps[0]; i < ps.length; i++) {
            let curr = ps[i];
            vertices.push(last.x, last.y, z1, curr.x, curr.y, z2, curr.x, curr.y, z1);
            vertices.push(last.x, last.y, z1, last.x, last.y, z2, curr.x, curr.y, z2);
            last = curr;
        }
    },

    addBoundsZ(vertices, ps, z1, z2) {
        // 内壁
        for (let i = 0, last = ps[ps.length - 1]; i < ps.length; i++) {
            let curr = ps[i];
            vertices.push(last.x, last.y, z1, curr.x, curr.y, z2, curr.x, curr.y, z1);
            vertices.push(last.x, last.y, z1, last.x, last.y, z2, curr.x, curr.y, z2);
            last = curr;
        }
    },

    addBoundsY(vertices, ps, y1, y2) {
        // 内壁
        for (let i = 0, last = ps[ps.length - 1]; i < ps.length; i++) {
            let curr = ps[i];
            vertices.push(last.y, y1, last.x, curr.y, y2, curr.x, curr.y, y1, curr.x);
            vertices.push(last.y, y1, last.x, last.y, y2, last.x, curr.y, y2, curr.x);
            last = curr;
        }
    },

    addFaceXY(vertices, { contour, holes = [], z }) {
        // 下表面：没有孔洞
        const faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let points = [...contour];
        holes.forEach(hole => points.push(...hole));
        faces.forEach(f => {
            vertices.push(points[f[0]].x, points[f[0]].y, z);
            vertices.push(points[f[1]].x, points[f[1]].y, z);
            vertices.push(points[f[2]].x, points[f[2]].y, z);
        });
    },
    addFaceXYReverse(vertices, { contour, holes = [], z }) {
        // 下表面：没有孔洞
        const faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let points = [...contour];
        holes.forEach(hole => points.push(...hole));
        faces.forEach(f => {
            vertices.push(points[f[0]].x, points[f[0]].y, z);
            vertices.push(points[f[2]].x, points[f[2]].y, z);
            vertices.push(points[f[1]].x, points[f[1]].y, z);
        });
    },
    addFaceYZ(vertices, { contour, holes = [], x }) {
        // 下表面：没有孔洞
        const faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let points = [...contour];
        holes.forEach(hole => points.push(...hole));
        faces.forEach(f => {
            vertices.push(x, points[f[0]].x, points[f[0]].y);
            vertices.push(x, points[f[1]].x, points[f[1]].y);
            vertices.push(x, points[f[2]].x, points[f[2]].y);
        });
    },
    addFaceYZReverse(vertices, { contour, holes = [], x }) {
        // 下表面：没有孔洞
        const faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let points = [...contour];
        holes.forEach(hole => points.push(...hole));
        faces.forEach(f => {
            vertices.push(x, points[f[0]].x, points[f[0]].y);
            vertices.push(x, points[f[2]].x, points[f[2]].y);
            vertices.push(x, points[f[1]].x, points[f[1]].y);
        });
    },
    addFaceZX(vertices, { contour, holes = [], y }) {
        // 下表面：没有孔洞
        const faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let points = [...contour];
        holes.forEach(hole => points.push(...hole));
        faces.forEach(f => {
            vertices.push(points[f[0]].y, y, points[f[0]].x);
            vertices.push(points[f[2]].y, y, points[f[2]].x);
            vertices.push(points[f[1]].y, y, points[f[1]].x);
        });
    },
    addFaceZXReverse(vertices, { contour, holes = [], y }) {
        // 下表面：没有孔洞
        const faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let points = [...contour];
        holes.forEach(hole => points.push(...hole));
        faces.forEach(f => {
            vertices.push(points[f[0]].y, y, points[f[0]].x);
            vertices.push(points[f[1]].y, y, points[f[1]].x);
            vertices.push(points[f[2]].y, y, points[f[2]].x);
        });
    },

    addFaceZY(vertices, { contour, holes = [], x }) {
        // 下表面：没有孔洞
        const faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let points = [...contour];
        holes.forEach(hole => points.push(...hole));
        faces.forEach(f => {
            vertices.push(x, points[f[0]].y, points[f[0]].x);
            vertices.push(x, points[f[1]].y, points[f[1]].x);
            vertices.push(x, points[f[2]].y, points[f[2]].x);
        });
    },
    addFaceZYReverse(vertices, { contour, holes = [], x }) {
        // 下表面：没有孔洞
        const faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let points = [...contour];
        holes.forEach(hole => points.push(...hole));
        faces.forEach(f => {
            vertices.push(x, points[f[0]].y, points[f[0]].x);
            vertices.push(x, points[f[2]].y, points[f[2]].x);
            vertices.push(x, points[f[1]].y, points[f[1]].x);
        });
    },

    // 添加旋转面：由旋转所生成的面。
    // 只需要知道截曲线（折线段）就可以确定。环绕整个一周，指定环绕的切割次数。
    makeRotateFaces(vertices, {
        points,
        N
    }) {
        for (let i = 0; i < points.length; i++) {
            let p = points[i];
            for (let j = 0; j < N; j++) {

            }
        }
    },

    addPolygonXY(vertices, contour, holes, z) {
        const faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let points = [...contour];
        holes.forEach(hole => points.push(...hole));
        faces.forEach(f => {
            vertices.push(points[f[0]].x, points[f[0]].y, z);
            vertices.push(points[f[1]].x, points[f[1]].y, z);
            vertices.push(points[f[2]].x, points[f[2]].y, z);
        });
    },

    addPolygonXYR(vertices, contour, holes, z) {
        const faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let points = [...contour];
        holes.forEach(hole => points.push(...hole));
        faces.forEach(f => {
            vertices.push(points[f[0]].x, points[f[0]].y, z);
            vertices.push(points[f[2]].x, points[f[2]].y, z);
            vertices.push(points[f[1]].x, points[f[1]].y, z);
        });
    },

    // 最基本的形状
    addShapeExtrude(vertices, {
        contour,
        holes = [],
        z1,
        z2
    }) {
        // 构造垂直壁
        let ps1 = contour.map(v => new THREE.Vector3(v.x, v.y, z1));
        let ps2 = contour.map(v => new THREE.Vector3(v.x, v.y, z2));
        this.addBound(vertices, ps2, ps1); // 外侧壁
        for (let i = 0; i < holes.length; i++) {
            let ps1 = holes[i].map(v => new THREE.Vector3(v.x, v.y, z1));
            let ps2 = holes[i].map(v => new THREE.Vector3(v.x, v.y, z2));
            this.addBound(vertices, ps2, ps1); // 内侧壁：短，从顶部开始，但是并没有触到底部，是悬空的。
        }
        // 下表面：没有孔洞
        const faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let points = [...contour];
        holes.forEach(hole => points.push(...hole));
        faces.forEach(f => {
            vertices.push(points[f[0]].x, points[f[0]].y, z1);
            vertices.push(points[f[2]].x, points[f[2]].y, z1);
            vertices.push(points[f[1]].x, points[f[1]].y, z1);
            vertices.push(points[f[0]].x, points[f[0]].y, z2);
            vertices.push(points[f[1]].x, points[f[1]].y, z2);
            vertices.push(points[f[2]].x, points[f[2]].y, z2);
        });
    },

    // 最基本的形状
    addShapeExtrudeWithKnockout(vertices, {
        contour,
        holes = [],
        z1,
        z2,
        knockouts
    }) {
        // 构造垂直壁
        let ps1 = contour.map(v => new THREE.Vector3(v.x, v.y, z1));
        let ps2 = contour.map(v => new THREE.Vector3(v.x, v.y, z2));
        this.addBoundWithKnockout(vertices, ps1, ps2, knockouts); // 外侧壁
        for (let i = 0; i < holes.length; i++) {
            let ps1 = holes[i].map(v => new THREE.Vector3(v.x, v.y, z1));
            let ps2 = holes[i].map(v => new THREE.Vector3(v.x, v.y, z2));
            this.addBound(vertices, ps2, ps1); // 内侧壁：短，从顶部开始，但是并没有触到底部，是悬空的。
        }
        // 下表面：没有孔洞
        const faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let points = [...contour];
        holes.forEach(hole => points.push(...hole));
        faces.forEach(f => {
            vertices.push(points[f[0]].x, points[f[0]].y, z1);
            vertices.push(points[f[2]].x, points[f[2]].y, z1);
            vertices.push(points[f[1]].x, points[f[1]].y, z1);
            vertices.push(points[f[0]].x, points[f[0]].y, z2);
            vertices.push(points[f[1]].x, points[f[1]].y, z2);
            vertices.push(points[f[2]].x, points[f[2]].y, z2);
        });
    },

    // 最基本的形状
    addShapeExtrudeZX(vertices, {
        contour,
        holes = [],
        y1,
        y2
    }) {
        // 构造垂直壁
        let ps1 = contour.map(v => new THREE.Vector3(v.y, y1, v.x));
        let ps2 = contour.map(v => new THREE.Vector3(v.y, y2, v.x));
        this.addBound(vertices, ps2, ps1); // 外侧壁
        for (let i = 0; i < holes.length; i++) {
            let ps1 = holes[i].map(v => new THREE.Vector3(v.y, y1, v.x));
            let ps2 = holes[i].map(v => new THREE.Vector3(v.y, y2, v.x));
            this.addBound(vertices, ps2, ps1); // 内侧壁：短，从顶部开始，但是并没有触到底部，是悬空的。
        }
        // 下表面：没有孔洞
        const faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let points = [...contour];
        holes.forEach(hole => points.push(...hole));
        faces.forEach(f => {
            vertices.push(points[f[0]].y, y1, points[f[0]].x);
            vertices.push(points[f[2]].y, y1, points[f[2]].x);
            vertices.push(points[f[1]].y, y1, points[f[1]].x);
            vertices.push(points[f[0]].y, y2, points[f[0]].x);
            vertices.push(points[f[1]].y, y2, points[f[1]].x);
            vertices.push(points[f[2]].y, y2, points[f[2]].x);
        });
    },

    // 最基本的形状
    addShapeExtrudeXY(vertices, options) {
        this.addShapeExtrude(vertices, options);
    },

    addPolyTreeZX(vertices, polytree, y1, y2) {
        for (let i = 0, nodes = polytree.Childs(); i < nodes.length; i++) {
            let node = nodes[i];
            let path = {
                shape: node.Contour().map(fPointToVector2),
                holes: node.Childs().map(holeNode => holeNode.Contour().map(fPointToVector2))
            };
            const faces = THREE.ShapeUtils.triangulateShape(path.shape, path.holes);
            let points = [...path.shape];
            path.holes.forEach(hole => { points.push(...hole); });
            faces.forEach(f => {
                let p1 = points[f[0]];
                let p2 = points[f[1]];
                let p3 = points[f[2]];
                vertices.push(p1.y, y1, p1.x);
                vertices.push(p3.y, y1, p3.x);
                vertices.push(p2.y, y1, p2.x);
                vertices.push(p1.y, y2, p1.x);
                vertices.push(p2.y, y2, p2.x);
                vertices.push(p3.y, y2, p3.x);
            });
            this.addBoundsY(vertices, path.shape, y2, y1);
            path.holes.forEach(hole => { this.addBoundsY(vertices, hole, y2, y1); });
            node.Childs().forEach(subNode => { nodes.push(...subNode.Childs()); });
        }
    },

    // 柱面上添加
    addPolyTreeZXCylinder(vertices, polytree, r1, r2, skip1, skip2) {
        let addBound = function (points) {
            for (let i = 0, last = points[points.length - 1]; i < points.length; i++) {
                let curr = points[i];
                if (!((last.x === skip1 && curr.x === skip1) || (last.x === skip2 && curr.x === skip2))) {
                    vertices.push(
                        last.y, Math.cos(last.x) * r2, Math.sin(last.x) * r2,
                        curr.y, Math.cos(curr.x) * r1, Math.sin(curr.x) * r1,
                        curr.y, Math.cos(curr.x) * r2, Math.sin(curr.x) * r2
                    );
                    vertices.push(
                        last.y, Math.cos(last.x) * r2, Math.sin(last.x) * r2,
                        last.y, Math.cos(last.x) * r1, Math.sin(last.x) * r1,
                        curr.y, Math.cos(curr.x) * r1, Math.sin(curr.x) * r1
                    );
                }
                last = curr;
            }
        };

        for (let i = 0, nodes = polytree.Childs(); i < nodes.length; i++) {
            let node = nodes[i];
            let path = {
                shape: node.Contour().map(fPointToVector2),
                holes: node.Childs().map(holeNode => holeNode.Contour().map(fPointToVector2))
            };
            const faces = THREE.ShapeUtils.triangulateShape(path.shape, path.holes);
            let points = [...path.shape];
            path.holes.forEach(hole => { points.push(...hole); });
            faces.forEach(f => {
                let p1 = points[f[0]];
                let p2 = points[f[1]];
                let p3 = points[f[2]];
                vertices.push(p1.y, Math.cos(p1.x) * r1, Math.sin(p1.x) * r1);
                vertices.push(p3.y, Math.cos(p3.x) * r1, Math.sin(p3.x) * r1);
                vertices.push(p2.y, Math.cos(p2.x) * r1, Math.sin(p2.x) * r1);
                vertices.push(p1.y, Math.cos(p1.x) * r2, Math.sin(p1.x) * r2);
                vertices.push(p2.y, Math.cos(p2.x) * r2, Math.sin(p2.x) * r2);
                vertices.push(p3.y, Math.cos(p3.x) * r2, Math.sin(p3.x) * r2);
            });
            addBound(path.shape);
            path.holes.forEach(hole => { addBound(hole); });
            node.Childs().forEach(subNode => { nodes.push(...subNode.Childs()); });
        }
    },

    addShapeListAsHoleForPlaneReplace(vertices, bound, shapeList, y1, y2) {
        let solution = new ClipperLib.PolyTree();
        let c = new ClipperLib.Clipper();
        c.AddPath(bound, ClipperLib.PolyType.ptSubject, true);
        shapeList.forEach(shape => {
            c.AddPaths([
                shape.shape.map(vector2ToFPoint),
                ...shape.holes.map(hole => hole.map(vector2ToFPoint))
            ], ClipperLib.PolyType.ptClip, true);
        });
        c.Execute(ClipperLib.ClipType.ctDifference, solution);

        // 只有一层
        for (let i = 0, nodes = solution.Childs(); i < nodes.length; i++) {
            let node = nodes[i];
            let path = {
                shape: node.Contour().map(fPointToVector2),
                holes: node.Childs().map(holeNode => holeNode.Contour().map(fPointToVector2))
            };

            const faces = THREE.ShapeUtils.triangulateShape(path.shape, path.holes);
            let points = [...path.shape];
            path.holes.forEach(hole => { points.push(...hole); });
            faces.forEach(f => {
                let p1 = points[f[0]];
                let p2 = points[f[1]];
                let p3 = points[f[2]];
                vertices.push(p1.y, y2, p1.x);
                vertices.push(p2.y, y2, p2.x);
                vertices.push(p3.y, y2, p3.x);
            });
            node.Childs().forEach(subNode => { nodes.push(...subNode.Childs()); });
        }

        shapeList.forEach(shape => {
            this.addFaceZXReverse(vertices, {
                contour: shape.shape,
                holes: shape.holes,
                y: y1
            });
            this.addBound(
                vertices,
                shape.shape.map(p => new THREE.Vector3(p.y, y1, p.x)),
                shape.shape.map(p => new THREE.Vector3(p.y, y2, p.x))
            );
            shape.holes.forEach(hole => {
                this.addBound(
                    vertices,
                    hole.map(p => new THREE.Vector3(p.y, y1, p.x)),
                    hole.map(p => new THREE.Vector3(p.y, y2, p.x))
                );
            });
        });
    },

    rotateExtrude(vertices, {
        points,
        fn = 128
    }) {
        let polyList = [];
        for (let i = 0; i < fn; i++) {
            const rad = i / fn * Math.PI * 2;
            const cos = Math.cos(rad);
            const sin = Math.sin(rad);
            polyList.push(points.map(p => new THREE.Vector3(p.x * cos, p.x * sin, p.y)));
        }
        for (let i = 0, last = polyList[polyList.length - 1]; i < fn; i++) {
            let curr = polyList[i];
            this.addBound(vertices, last, curr);
            last = curr;
        }
    },

    rotateExtrudeOpen(vertices, {
        points,
        fn = 128
    }) {
        let polyList = [];
        for (let i = 0; i < fn; i++) {
            const rad = i / fn * Math.PI * 2;
            const cos = Math.cos(rad);
            const sin = Math.sin(rad);
            polyList.push(points.map(p => new THREE.Vector3(p.x * cos, p.x * sin, p.y)));
        }
        for (let i = 1, last = polyList[0]; i < fn; i++) {
            let curr = polyList[i];
            this.addBound(vertices, last, curr);
            last = curr;
        }
    },

    rotateX90(vertices) {

    },

    // 三层，最外面一层是底，中间一层和最里面一层形成了凸起，最里面一层再形成底。
    // 就好比是，最外面一层形成一个板。然后里面两层是正常的挤出。拼接而成。
    addShapeExtrude2(vertices, {
        baseContour,
        pathList,
        baseZ, // 基底的z
        baseThickness, // 基底的厚度
        toothThickness // 凸起部分的厚度
    }) { },

    // 一般的挤出，孔是穿透的。这里的孔只穿透一半，形成一个凹槽
    // 此外，如果holeDepth取负值，则形成一个凸起
    addShapeExtrudeHolesOneSide(vertices, {
        contour,
        holes,
        top,
        bottom,
        holeDepth
    }) {
        let z1 = top;
        let z2 = bottom;
        let z3 = bottom - holeDepth;
        // 构造垂直壁
        let ps1 = contour.map(v => new THREE.Vector3(v.x, v.y, z1));
        let ps2 = contour.map(v => new THREE.Vector3(v.x, v.y, z2));
        this.addBound(vertices, ps1, ps2); // 外侧壁
        for (let i = 0; i < holes.length; i++) {
            let ps1 = holes[i].map(v => new THREE.Vector3(v.x, v.y, z3));
            let ps2 = holes[i].map(v => new THREE.Vector3(v.x, v.y, z2));
            this.addBound(vertices, ps2, ps1); // 内侧壁：短，从顶部开始，但是并没有触到底部，是悬空的。
        }
        // 下表面：没有孔洞
        const faces = THREE.ShapeUtils.triangulateShape(contour, []);
        // console.log("faces", faces);
        faces.forEach(f => {
            vertices.push(contour[f[0]].x, contour[f[0]].y, z1);
            vertices.push(contour[f[2]].x, contour[f[2]].y, z1);
            vertices.push(contour[f[1]].x, contour[f[1]].y, z1);
        });

        // 上表面：有孔洞
        const faces2 = THREE.ShapeUtils.triangulateShape(contour, holes);
        let points = [].concat(contour);
        for (let i = 0; i < holes.length; i++) {
            points = points.concat(holes[i]);
        }

        faces2.forEach(f => {
            vertices.push(points[f[0]].x, points[f[0]].y, z2);
            vertices.push(points[f[1]].x, points[f[1]].y, z2);
            vertices.push(points[f[2]].x, points[f[2]].y, z2);
        });
        // 中间面：从内部壁的悬空处开始，把空洞填补起来
        for (let i = 0; i < holes.length; i++) {
            let hole = holes[i];
            const faces3 = THREE.ShapeUtils.triangulateShape(hole, []);

            faces3.forEach(f => {
                vertices.push(hole[f[0]].x, hole[f[0]].y, z3);
                vertices.push(hole[f[1]].x, hole[f[1]].y, z3);
                vertices.push(hole[f[2]].x, hole[f[2]].y, z3);
            });
        }
    },

    // 一般的挤出，孔是穿透的。这里的孔只穿透一半，形成一个凹槽
    // 此外，如果holeDepth取负值，则形成一个凸起
    addShapeExtrudeHolesOneSideWithKnockout(vertices, {
        contour,
        holes,
        top,
        bottom,
        holeDepth,
        knockouts
    }) {
        let z1 = top;
        let z2 = bottom;
        let z3 = bottom - holeDepth;
        // 构造垂直壁
        let ps1 = contour.map(v => new THREE.Vector3(v.x, v.y, z1));
        let ps2 = contour.map(v => new THREE.Vector3(v.x, v.y, z2));
        this.addBoundWithKnockout(vertices, ps1, ps2, knockouts); // 外侧壁
        for (let i = 0; i < holes.length; i++) {
            let ps1 = holes[i].map(v => new THREE.Vector3(v.x, v.y, z3));
            let ps2 = holes[i].map(v => new THREE.Vector3(v.x, v.y, z2));
            this.addBound(vertices, ps2, ps1); // 内侧壁：短，从顶部开始，但是并没有触到底部，是悬空的。
        }
        // 下表面：没有孔洞
        const faces = THREE.ShapeUtils.triangulateShape(contour, []);
        // console.log("faces", faces);
        faces.forEach(f => {
            vertices.push(contour[f[0]].x, contour[f[0]].y, z1);
            vertices.push(contour[f[2]].x, contour[f[2]].y, z1);
            vertices.push(contour[f[1]].x, contour[f[1]].y, z1);
        });

        // 上表面：有孔洞
        const faces2 = THREE.ShapeUtils.triangulateShape(contour, holes);
        let points = [].concat(contour);
        for (let i = 0; i < holes.length; i++) {
            points = points.concat(holes[i]);
        }

        faces2.forEach(f => {
            vertices.push(points[f[0]].x, points[f[0]].y, z2);
            vertices.push(points[f[1]].x, points[f[1]].y, z2);
            vertices.push(points[f[2]].x, points[f[2]].y, z2);
        });
        // 中间面：从内部壁的悬空处开始，把空洞填补起来
        for (let i = 0; i < holes.length; i++) {
            let hole = holes[i];
            const faces3 = THREE.ShapeUtils.triangulateShape(hole, []);

            faces3.forEach(f => {
                vertices.push(hole[f[0]].x, hole[f[0]].y, z3);
                vertices.push(hole[f[1]].x, hole[f[1]].y, z3);
                vertices.push(hole[f[2]].x, hole[f[2]].y, z3);
            });
        }
    },

    makeTextShapeSimple({
        char,
        font,
        height,
        curveSegments = 36,
        center = true
    }) {
        // 获取文字的形状
        console.log(font);
        let charShapes = createPath(char, 12, 0, 0, font.data).path.toShapes();
        // 转成点列
        let charShapePoints = charShapes.map(shape => shape.extractPoints(curveSegments));
        // 逐个获取范围
        let boundAll = new THREE.Box2();
        charShapePoints.forEach(shapePoints => {
            shapePoints.shape.forEach(p => boundAll.expandByPoint(p));
        });
        // 重新排布
        let textOriginSize = boundAll.getSize();
        let shapeList = [];
        let translate = center ? boundAll.center().negate() : new THREE.Vector2(0, 0);
        let scale = height / textOriginSize.y;
        let transofrm = p => p.add(translate).multiplyScalar(scale);
        for (let shapePoints of charShapePoints) {
            shapePoints.shape.forEach(transofrm);
            shapePoints.holes.forEach(hole => hole.forEach(transofrm));
            shapeList.push(shapePoints);
        }

        return shapeList;
    },

    makeTextShapesSimple({
        text,
        font,
        height,
        curveSegments = 36,
        center = true
    }) {
        // 获取文字的形状
        let charShapesList = createPaths(text, 12, font.data).map(shapePath => shapePath.toShapes());
        // 转成点列
        let charShapePointsList = charShapesList.map(charShapes => charShapes.map(shape => shape.extractPoints(curveSegments)));
        // 逐个获取范围
        let boundAll = new THREE.Box2();
        charShapePointsList.forEach(charShapePoints => {
            let bound = new THREE.Box2();
            charShapePoints.forEach(shapePoints => {
                shapePoints.shape.forEach(p => bound.expandByPoint(p));
            });
            boundAll.expandByPoint(bound.max);
            boundAll.expandByPoint(bound.min);
        });
        // 重新排布
        let textOriginSize = boundAll.getSize();
        let shapeList = [];
        let translate = center ? boundAll.center().negate() : new THREE.Vector2(0, 0);
        let scale = height / textOriginSize.y;
        for (let i = 0; i < charShapePointsList.length; i++) {
            let charShapePoints = charShapePointsList[i];
            let transofrm = p => p.add(translate).multiplyScalar(scale);
            for (let shapePoints of charShapePoints) {
                shapePoints.shape.forEach(transofrm);
                shapePoints.holes.forEach(hole => hole.forEach(transofrm));
                shapeList.push(shapePoints);
            }
        }

        return shapeList;
    },

    makeTextShapesSimpleVertical({
        text,
        font,
        height,
        curveSegments = 36,
        center = true
    }) {
        // 获取文字的形状
        let charShapesList = createPaths(text, 12, font.data).map(shapePath => shapePath.toShapes());
        // 转成点列
        let charShapePointsList = charShapesList.map(charShapes => charShapes.map(shape => shape.extractPoints(curveSegments)));
        // 逐个获取范围
        let boundAll = new THREE.Box2();
        let boundList = charShapePointsList.map(charShapePoints => {
            let bound = new THREE.Box2();
            charShapePoints.forEach(shapePoints => {
                shapePoints.shape.forEach(p => bound.expandByPoint(p));
            });
            boundAll.expandByPoint(bound.max);
            boundAll.expandByPoint(bound.min);
            return bound;
        });
        // 重新排布
        let textOriginSize = boundAll.getSize();
        let shapeList = [];
        let translate = center ? boundAll.center().negate() : new THREE.Vector2(0, 0);
        let scale = height / textOriginSize.y;
        let shiftY = 0;
        for (let i = 0; i < charShapePointsList.length; i++) {
            let charShapePoints = charShapePointsList[i];
            let center = boundList[i].getCenter();
            let transofrm = p => {
                modeller2d.rotate90(p.sub(center)).add(center);
                p.x += shiftY;
            }
            if (i < charShapePointsList.length - 1) {
                let size1 = boundList[i].getSize();
                let size2 = boundList[i + 1].getSize();
                shiftY += (size1.y - size1.x) * 0.5 + (size2.y - size2.x) * 0.5;
            }
            console.log("shiftY", shiftY);
            for (let shapePoints of charShapePoints) {
                shapePoints.shape.forEach(transofrm);
                shapePoints.holes.forEach(hole => hole.forEach(transofrm));
                shapeList.push(shapePoints);
            }
        }
        boundAll = new THREE.Box2();
        charShapePointsList.forEach(charShapePoints => {
            let bound = new THREE.Box2();
            charShapePoints.forEach(shapePoints => {
                shapePoints.shape.forEach(p => bound.expandByPoint(p));
            });
            boundAll.expandByPoint(bound.max);
            boundAll.expandByPoint(bound.min);
        });
        for (let i = 0; i < charShapePointsList.length; i++) {
            let charShapePoints = charShapePointsList[i];
            let transofrm = p => {
                p.add(translate).multiplyScalar(scale);
            }
            for (let shapePoints of charShapePoints) {
                shapePoints.shape.forEach(transofrm);
                shapePoints.holes.forEach(hole => hole.forEach(transofrm));
                shapeList.push(shapePoints);
            }
        }

        return shapeList;
    },

    makeTextShapesSimpleVertical2({
        text,
        font,
        fontSize,
        curveSegments = 36,
        center = true
    }) {
        // 获取文字的形状
        let text2 = text.split('').join("\n");
        console.log("text2", text2);
        // 获取文字的形状
        let charShapesList = createPaths(text2, fontSize, font.data).map(shapePath => shapePath.toShapes());
        // 转成点列
        let charShapePointsList = charShapesList.map(charShapes => charShapes.map(shape => shape.extractPoints(curveSegments)));
        // 逐个获取范围
        let boundAll = new THREE.Box2();
        charShapePointsList.forEach(charShapePoints => {
            let bound = new THREE.Box2();
            charShapePoints.forEach(shapePoints => {
                shapePoints.shape.forEach(p => bound.expandByPoint(p));
            });
            boundAll.expandByPoint(bound.max);
            boundAll.expandByPoint(bound.min);
        });
        // 重新排布
        let shapeList = [];
        let translate = center ? boundAll.center().negate() : new THREE.Vector2(0, 0);
        for (let i = 0; i < charShapePointsList.length; i++) {
            let charShapePoints = charShapePointsList[i];
            let transofrm = p => p.add(translate);
            for (let shapePoints of charShapePoints) {
                shapePoints.shape.forEach(transofrm);
                shapePoints.holes.forEach(hole => hole.forEach(transofrm));
                shapeList.push(shapePoints);
            }
        }

        return shapeList;
    },

    makeTextShapes({
        text,
        font,
        width,
        height,
        curveSegments = 36,
        center = true
    }) {
        // 获取文字的形状
        let charShapesList = createPaths(text, 12, font.data).map(shapePath => shapePath.toShapes());
        // 转成点列
        let charShapePointsList = charShapesList.map(charShapes => charShapes.map(shape => shape.extractPoints(curveSegments)));
        // 逐个获取范围
        let boundAll = new THREE.Box2();
        charShapePointsList.forEach(charShapePoints => {
            let bound = new THREE.Box2();
            charShapePoints.forEach(shapePoints => {
                shapePoints.shape.forEach(p => bound.expandByPoint(p));
            });
            boundAll.expandByPoint(bound.max);
            boundAll.expandByPoint(bound.min);
        });
        // 重新排布
        let textOriginSize = boundAll.getSize();
        let textRatio = textOriginSize.y / textOriginSize.x;
        let ratio = height / width;
        let shapeList = [];
        let translate = center ? boundAll.center().negate() : new THREE.Vector2(0, 0);
        if (charShapePointsList.length > 1) {
            let scale = 1.0;
            let charGap = 0;
            if (textRatio > ratio) {
                scale = height / textOriginSize.y;
                // 分散
                let textWidth = textOriginSize.x * scale;
                charGap = (width - textWidth) / (charShapePointsList.length - 1) / scale;
            } else if (textRatio < ratio) {
                scale = width / textOriginSize.x;
            }

            for (let i = 0; i < charShapePointsList.length; i++) {
                let charShapePoints = charShapePointsList[i];
                let translateChar = translate.clone();
                translateChar.x += charGap * (i - (charShapePointsList.length - 1) * 0.5);
                let transofrm = p => p.add(translateChar).multiplyScalar(scale);
                for (let shapePoints of charShapePoints) {
                    shapePoints.shape.forEach(transofrm);
                    shapePoints.holes.forEach(hole => hole.forEach(transofrm));
                    shapeList.push(shapePoints);
                }
            }
        } else {
            if (textRatio > ratio) {
                scale = height / textOriginSize.y;
            } else if (textRatio < ratio) {
                scale = width / textOriginSize.x;
            }
            for (let i = 0; i < charShapePointsList.length; i++) {
                let charShapePoints = charShapePointsList[i];
                let translateChar = translate.clone();
                let transofrm = p => p.add(translateChar).multiplyScalar(scale);
                for (let shapePoints of charShapePoints) {
                    shapePoints.shape.forEach(transofrm);
                    shapePoints.holes.forEach(hole => hole.forEach(transofrm));
                    shapeList.push(shapePoints);
                }
            }
        }

        return shapeList;
    },

    makeTextShapesInCircle({
        text,
        font,
        cx,
        cy,
        radius,
        curveSegments = 36
    }) {
        // 获取文字的形状
        let charShapesList = createPaths(text, 12, font.data).map(shapePath => shapePath.toShapes());
        // 转成点列
        let charShapePointsList = charShapesList.map(charShapes => charShapes.map(shape => shape.extractPoints(curveSegments)));
        // 逐个获取范围
        let points = charShapePointsList.flatMap(charShapePoints => charShapePoints.flatMap(shapePoints => shapePoints.shape));
        let cir = modeller2d.getBoundingCircle(points);
        let scale = radius / cir.radius;
        let center = new THREE.Vector2(cx, cy);
        let shapeList = [];
        let transofrm = p => p.sub(cir.center).multiplyScalar(scale).add(center);
        for (let i = 0; i < charShapePointsList.length; i++) {
            let charShapePoints = charShapePointsList[i];
            for (let shapePoints of charShapePoints) {
                shapePoints.shape.forEach(transofrm);
                shapePoints.holes.forEach(hole => hole.forEach(transofrm));
                shapeList.push(shapePoints);
            }
        }

        return shapeList;
    },

    buildPlaneZXPositivte(vertices, zs, xs, y) {
        for (let i = 0, ni = xs.length - 1; i < ni; i++) {
            let x1 = xs[i],
                x2 = xs[i + 1];
            for (let j = 0, nj = zs.length - 1; j < nj; j++) {
                let z1 = zs[j],
                    z2 = zs[j + 1];
                vertices.push(
                    x1, y, z1, x2, y, z2, x2, y, z1,
                    x1, y, z1, x1, y, z2, x2, y, z2
                );
            }
        }
    },

    buildPlaneZXPositivteIncreaseFunction(vertices, zs, xs, yFunc) {
        for (let i = 0, ni = xs.length - 1; i < ni; i++) {
            let x1 = xs[i],
                x2 = xs[i + 1],
                x3 = (x1 + x2) * 0.5;
            for (let j = 0, nj = zs.length - 1; j < nj; j++) {
                let z1 = zs[j],
                    z2 = zs[j + 1],
                    z3 = (z1 + z2) * 0.5;
                let y1 = yFunc(i, j),
                    y2 = yFunc(i + 1, j),
                    y3 = yFunc(i + 1, j + 1),
                    y4 = yFunc(i, j + 1);
                let y = (y1 + y2 + y3 + y4) * 0.25;
                vertices.push(
                    x3, y, z3, x2, y2, z1, x1, y1, z1,
                    x3, y, z3, x2, y3, z2, x2, y2, z1,
                    x3, y, z3, x1, y4, z2, x2, y3, z2,
                    x3, y, z3, x1, y1, z1, x1, y4, z2,
                );
            }
        }
    },

    // 敲除某一块
    buildPlaneZXPositivteWithKnockout(vertices, zs, xs, y, zIndex, xIndex) {
        for (let i = 0, ni = xs.length - 1; i < ni; i++) {
            let x1 = xs[i],
                x2 = xs[i + 1];
            for (let j = 0, nj = zs.length - 1; j < nj; j++) {
                let z1 = zs[j],
                    z2 = zs[j + 1];
                if (i === xIndex && j === zIndex) continue;
                vertices.push(
                    x1, y, z1, x2, y, z2, x2, y, z1,
                    x1, y, z1, x1, y, z2, x2, y, z2
                );
            }
        }
    },

    // 增密
    // 敲除某一块
    buildPlaneZXPositivteWithKnockoutIncrease(vertices, zs, xs, y, zIndex, xIndex) {
        for (let i = 0, ni = xs.length - 1; i < ni; i++) {
            let x1 = xs[i],
                x2 = xs[i + 1],
                x3 = (x1 + x2) * 0.5;
            for (let j = 0, nj = zs.length - 1; j < nj; j++) {
                let z1 = zs[j],
                    z2 = zs[j + 1],
                    z3 = (z1 + z2) * 0.5;
                if (i === xIndex && j === zIndex) continue;
                vertices.push(
                    z3, y, x3, z2, y, x1, z1, y, x1,
                    z3, y, x3, z2, y, x2, z2, y, x1,
                    z3, y, x3, z1, y, x2, z2, y, x2,
                    z3, y, x3, z1, y, x1, z1, y, x2,
                );
            }
        }
    },

    buildPlaneZXNegative(vertices, zs, xs, y) {
        for (let i = 0, ni = xs.length - 1; i < ni; i++) {
            let x1 = xs[i],
                x2 = xs[i + 1];
            for (let j = 0, nj = zs.length - 1; j < nj; j++) {
                let z1 = zs[j],
                    z2 = zs[j + 1];
                vertices.push(
                    x1, y, z1, x2, y, z1, x2, y, z2,
                    x1, y, z1, x2, y, z2, x1, y, z2
                );
            }
        }
    },

    buildPlaneZXNegativeIncreaseFunction(vertices, zs, xs, yFunc) {
        for (let i = 0, ni = xs.length - 1; i < ni; i++) {
            let x1 = xs[i],
                x2 = xs[i + 1],
                x3 = (x1 + x2) * 0.5;
            for (let j = 0, nj = zs.length - 1; j < nj; j++) {
                let z1 = zs[j],
                    z2 = zs[j + 1],
                    z3 = (z1 + z2) * 0.5;
                let y1 = yFunc(i, j),
                    y2 = yFunc(i + 1, j),
                    y3 = yFunc(i + 1, j + 1),
                    y4 = yFunc(i, j + 1);
                let y = (y1 + y2 + y3 + y4) * 0.25;
                if (i == 2 && j == 10) console.log(y1, y2, y3, y4, y);
                vertices.push(
                    x3, y, z3, x1, y1, z1, x2, y2, z1,
                    x3, y, z3, x2, y2, z1, x2, y3, z2,
                    x3, y, z3, x2, y3, z2, x1, y4, z2,
                    x3, y, z3, x1, y4, z2, x1, y1, z1,
                );
            }
        }
    },

    // 敲除某一块
    buildPlaneZXNegativeWithKnockout(vertices, zs, xs, y, zIndex, xIndex) {
        for (let i = 0, ni = xs.length - 1; i < ni; i++) {
            let x1 = xs[i],
                x2 = xs[i + 1];
            for (let j = 0, nj = zs.length - 1; j < nj; j++) {
                let z1 = zs[j],
                    z2 = zs[j + 1];
                if (i === xIndex && j === zIndex) continue;
                vertices.push(
                    x1, y, z1, x2, y, z1, x2, y, z2,
                    x1, y, z1, x2, y, z2, x1, y, z2
                );
            }
        }
    },

    buildPlaneXYPositivte(vertices, xs, ys, z) {
        for (let i = 0, ni = xs.length - 1; i < ni; i++) {
            let x1 = xs[i],
                x2 = xs[i + 1];
            for (let j = 0, nj = ys.length - 1; j < nj; j++) {
                let y1 = ys[j],
                    y2 = ys[j + 1];
                vertices.push(
                    x1, y1, z, x2, y1, z, x2, y2, z,
                    x1, y1, z, x2, y2, z, x1, y2, z
                );
            }
        }
    },

    buildPlaneXYNegative(vertices, xs, ys, z) {
        for (let i = 0, ni = xs.length - 1; i < ni; i++) {
            let x1 = xs[i],
                x2 = xs[i + 1];
            for (let j = 0, nj = ys.length - 1; j < nj; j++) {
                let y1 = ys[j],
                    y2 = ys[j + 1];
                vertices.push(
                    x1, y1, z, x2, y2, z, x2, y1, z,
                    x1, y1, z, x1, y2, z, x2, y2, z
                );
            }
        }
    },

    buildPlaneYZPositivte(vertices, ys, zs, x) {
        for (let i = 0, ni = ys.length - 1; i < ni; i++) {
            let y1 = ys[i],
                y2 = ys[i + 1];
            for (let j = 0, nj = zs.length - 1; j < nj; j++) {
                let z1 = zs[j],
                    z2 = zs[j + 1];
                vertices.push(
                    x, y1, z1, x, y2, z1, x, y2, z2,
                    x, y1, z1, x, y2, z2, x, y1, z2
                );
            }
        }
    },

    buildPlaneYZNegative(vertices, ys, zs, x) {
        for (let i = 0, ni = ys.length - 1; i < ni; i++) {
            let y1 = ys[i],
                y2 = ys[i + 1];
            for (let j = 0, nj = zs.length - 1; j < nj; j++) {
                let z1 = zs[j],
                    z2 = zs[j + 1];
                vertices.push(
                    x, y1, z1, x, y2, z2, x, y2, z1,
                    x, y1, z1, x, y1, z2, x, y2, z2
                );
            }
        }
    },

    mapBasis(points2d, o, nx, ny) {
        return points2d.map(p => new THREE.Vector3(
            p.x * nx.x + p.y * ny.x + o.x,
            p.x * nx.y + p.y * ny.y + o.y,
            p.x * nx.z + p.y * ny.z + o.z
        ));
    },

    // 获取一个向量的任意垂直向量
    // https://blog.csdn.net/binbinstrong/article/details/101669126
    // a·b=0 {x1,y1,z1}·b=0 根据公式只需要构造任意一个与a垂直的向量b即可 b= {(y1+z1),(-x1+z1),(-x1-y1)} {x1,y1,z1}·{(y1+z1),(-x1+z1),(-x1-y1)} = 0
    getNormal1(dir) {
        return new THREE.Vector3(dir.y + dir.z, -dir.x + dir.z, -dir.x - dir.y);
    },

    addStick(vertices, a, b, r, fn) {
        let nz = new THREE.Vector3().subVectors(b, a).normalize();
        let nx = this.getNormal1(nz).normalize();
        let ny = new THREE.Vector3().crossVectors(nz, nx);
        let circle = modeller2d.makeCircle(fn === undefined ? 16 : fn);
        circle.forEach(p => { p.multiplyScalar(r); });
        let circle1 = this.mapBasis(circle, a, nx, ny);
        let circle2 = this.mapBasis(circle, b, nx, ny);
        this.addBound(vertices, circle1, circle2);
        this.addCircle(vertices, circle1, a);
        this.addCircle(vertices, circle2.reverse(), b);
    },

    addGeometry(vertices, geom, origin) {
        if (geom.index) {
            for (let i = 0; i < geom.index.count; i++) {
                let index = geom.index.array[i];
                let v = new THREE.Vector3().fromBufferAttribute(geom.attributes.position, index);
                vertices.push(v.x + origin.x, v.y + origin.y, v.z + origin.z);
            }
        } else {
            for (let i = 0; i < geom.attributes.position.array.length; i += 3) {
                vertices.push(
                    geom.attributes.position.array[i] + origin.x,
                    geom.attributes.position.array[i + 1] + origin.y,
                    geom.attributes.position.array[i + 2] + origin.z
                );
            }
        }
    },

    addVertices(vertices, geom) {
        vertices.push(...geom);
    },

    toVertices(geom) {
        if (geom.index) {
            let vertices = [];
            for (let i = 0; i < geom.index.count; i++) {
                let index = geom.index.array[i];
                let v = new THREE.Vector3().fromBufferAttribute(geom.attributes.position, index);
                vertices.push(v.x, v.y, v.z);
            }
        } else {
            return Array.from(geom.attributes.position.array);
        }
    },
};

import * as THREE from 'three';


// WEBPACK FOOTER //
// ./src/views/makeVoroStand/scripts/Modeller.js